import { ref } from 'vue'
import { MEDIA_API } from '~/configs/api'
import { HttpRequestMethod } from '~/configs/enums'

import { useApi } from '~/composables/common/use-api'
import { ResponseStatus } from '~composables/common/interface'

import type { MatchData } from '~/utils/interface'

export function useHotmatches() {
  const { request } = useApi()
  const hotmatches = reactive<MatchData[]>([])
  const isLoadingHotmatch = ref(false)

  async function getHotmatches(): Promise<void> {
    isLoadingHotmatch.value = true
    try {
      const { data } = await useAsyncData(
        'hotmatches',
        async () =>
          await request(MEDIA_API.HOT_MATCH, { method: HttpRequestMethod.GET })
      )
      if (data.value?.status === ResponseStatus.OK && data.value?.data) {
        hotmatches.push(...data.value.data)
      }
    } finally {
      isLoadingHotmatch.value = false
    }
  }
  void getHotmatches()
  return { hotmatches, isLoadingHotmatch }
}
